/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import * as AssetCommands from "../modules/Asset/CommandsType";
import * as ViewEditorCommands from "../modules/ViewEditor/CommandsType";
import * as ReadmeEditorCommands from "../modules/ReadmeEditor/CommandsType";

export const CMD = {
	ASSET: AssetCommands,
	VIEW_EDITOR: ViewEditorCommands,
	README_EDITOR: ReadmeEditorCommands
};
